/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Drive_Announcement_DescriptionInputs */

const en_google_drive_announcement_description = /** @type {(inputs: Google_Drive_Announcement_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import Docs, PDFs, and more from your Drive, then listen right away.`)
};

const es_google_drive_announcement_description = /** @type {(inputs: Google_Drive_Announcement_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa documentos, PDF y más desde tu Drive y escúchalos al instante.`)
};

/**
* | output |
* | --- |
* | "Import Docs, PDFs, and more from your Drive, then listen right away." |
*
* @param {Google_Drive_Announcement_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const google_drive_announcement_description = /** @type {((inputs?: Google_Drive_Announcement_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Drive_Announcement_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_google_drive_announcement_description(inputs)
	return en_google_drive_announcement_description(inputs)
});